import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps, vModelRadio as _vModelRadio, withDirectives as _withDirectives, withCtx as _withCtx, vModelCheckbox as _vModelCheckbox, normalizeClass as _normalizeClass, createVNode as _createVNode } from "vue";
const _hoisted_1 = { class: "mt-2" };
const _hoisted_2 = { class: "col fw-bold" };
const _hoisted_3 = { class: "flex-fill" };
const _hoisted_4 = { class: "form-check" };
const _hoisted_5 = ["onUpdate:modelValue", "onChange"];
const _hoisted_6 = /*#__PURE__*/ _createElementVNode("label", { class: "form-check-label" }, " Ja ", -1);
const _hoisted_7 = { class: "form-check" };
const _hoisted_8 = ["onUpdate:modelValue", "onChange"];
const _hoisted_9 = /*#__PURE__*/ _createElementVNode("label", { class: "form-check-label" }, " Nein ", -1);
const _hoisted_10 = { class: "d-flex flex-row mt-3" };
const _hoisted_11 = { class: "form-check" };
const _hoisted_12 = ["onUpdate:modelValue", "onChange"];
const _hoisted_13 = {
    key: 0,
    class: "ms-3"
};
const _hoisted_14 = { class: "small" };
const _hoisted_15 = {
    key: 0,
    class: "mt-2"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_g_text_field = _resolveComponent("g-text-field");
    const _component_g_text_area = _resolveComponent("g-text-area");
    const _component_g_date_edit = _resolveComponent("g-date-edit");
    const _component_g_number_field = _resolveComponent("g-number-field");
    const _component_g_field_container = _resolveComponent("g-field-container");
    const _component_g_button = _resolveComponent("g-button");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.caption), 1),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.content.fields, (tField) => {
            return (_openBlock(), _createElementBlock("div", {
                key: tField.member,
                class: "d-flex flex-row"
            }, [
                _createElementVNode("div", _hoisted_3, [
                    (_ctx.element.dataType === 'string')
                        ? (_openBlock(), _createBlock(_component_g_text_field, {
                            key: 0,
                            label: _ctx.caption,
                            "show-label": false,
                            "read-only": _ctx.element.readOnly,
                            "max-length": _ctx.element.maxLength,
                            "data-member": tField.member,
                            "data-mode": "model",
                            "data-object": _ctx.data,
                            "error-message": tField.validation?.message,
                            onValidate: ($event) => (_ctx.onValueChanged(tField))
                        }, null, 8, ["label", "read-only", "max-length", "data-member", "data-object", "error-message", "onValidate"]))
                        : _createCommentVNode("", true),
                    (_ctx.element.dataType === 'memo')
                        ? (_openBlock(), _createBlock(_component_g_text_area, {
                            key: 1,
                            label: _ctx.caption,
                            "show-label": false,
                            "read-only": _ctx.element.readOnly,
                            "data-member": tField.member,
                            "data-mode": "model",
                            "data-object": _ctx.data,
                            rows: 5,
                            "error-message": tField.validation?.message,
                            onValidate: ($event) => (_ctx.onValueChanged(tField))
                        }, null, 8, ["label", "read-only", "data-member", "data-object", "error-message", "onValidate"]))
                        : (_ctx.element.dataType === 'date')
                            ? (_openBlock(), _createBlock(_component_g_date_edit, {
                                key: 2,
                                label: _ctx.caption,
                                "show-label": false,
                                "read-only": _ctx.element.readOnly,
                                "data-member": tField.member,
                                "data-mode": "model",
                                "data-object": _ctx.data,
                                "error-message": tField.validation?.message,
                                "show-clear-button": true,
                                onValidate: ($event) => (_ctx.onValueChanged(tField))
                            }, null, 8, ["label", "read-only", "data-member", "data-object", "error-message", "onValidate"]))
                            : (_ctx.element.dataType === 'integer')
                                ? (_openBlock(), _createBlock(_component_g_number_field, {
                                    key: 3,
                                    label: _ctx.caption,
                                    "show-label": false,
                                    "read-only": _ctx.element.readOnly,
                                    "data-member": tField.member,
                                    "data-mode": "model",
                                    "data-object": _ctx.data,
                                    "error-message": tField.validation?.message,
                                    onValidate: ($event) => (_ctx.onValueChanged(tField))
                                }, null, 8, ["label", "read-only", "data-member", "data-object", "error-message", "onValidate"]))
                                : (_ctx.element.dataType === 'decimal' || _ctx.element.dataType === 'money')
                                    ? (_openBlock(), _createBlock(_component_g_number_field, _mergeProps({ key: 4 }, _ctx.element.config, {
                                        label: _ctx.caption,
                                        "show-label": false,
                                        "read-only": _ctx.element.readOnly,
                                        "data-member": tField.member,
                                        "data-mode": "model",
                                        "data-object": _ctx.data,
                                        "error-message": tField.validation?.message,
                                        onValidate: ($event) => (_ctx.onValueChanged(tField))
                                    }), null, 16, ["label", "read-only", "data-member", "data-object", "error-message", "onValidate"]))
                                    : (_ctx.element.dataType === 'bool')
                                        ? (_openBlock(), _createBlock(_component_g_field_container, {
                                            key: 5,
                                            "error-message": tField.validation?.message
                                        }, {
                                            default: _withCtx(() => [
                                                _createElementVNode("div", _hoisted_4, [
                                                    _withDirectives(_createElementVNode("input", {
                                                        class: "form-check-input",
                                                        type: "radio",
                                                        "onUpdate:modelValue": ($event) => ((_ctx.data[tField.member]) = $event),
                                                        value: "true",
                                                        onChange: ($event) => (_ctx.onValueChanged(tField))
                                                    }, null, 40, _hoisted_5), [
                                                        [_vModelRadio, _ctx.data[tField.member]]
                                                    ]),
                                                    _hoisted_6
                                                ]),
                                                _createElementVNode("div", _hoisted_7, [
                                                    _withDirectives(_createElementVNode("input", {
                                                        class: "form-check-input",
                                                        type: "radio",
                                                        "onUpdate:modelValue": ($event) => ((_ctx.data[tField.member]) = $event),
                                                        value: "false",
                                                        onChange: ($event) => (_ctx.onValueChanged(tField))
                                                    }, null, 40, _hoisted_8), [
                                                        [_vModelRadio, _ctx.data[tField.member]]
                                                    ]),
                                                    _hoisted_9
                                                ])
                                            ]),
                                            _: 2
                                        }, 1032, ["error-message"]))
                                        : (_ctx.element.dataType === 'check')
                                            ? (_openBlock(), _createBlock(_component_g_field_container, {
                                                key: 6,
                                                "error-message": tField.validation?.message
                                            }, {
                                                default: _withCtx(() => [
                                                    _createElementVNode("div", _hoisted_10, [
                                                        _createElementVNode("div", _hoisted_11, [
                                                            _withDirectives(_createElementVNode("input", {
                                                                class: "form-check-input",
                                                                type: "checkbox",
                                                                "onUpdate:modelValue": ($event) => ((_ctx.data[tField.member]) = $event),
                                                                "true-value": "Ja",
                                                                "false-value": "Nein",
                                                                value: "",
                                                                onChange: ($event) => (_ctx.onValueChanged(tField))
                                                            }, null, 40, _hoisted_12), [
                                                                [_vModelCheckbox, _ctx.data[tField.member]]
                                                            ]),
                                                            _createElementVNode("label", {
                                                                class: _normalizeClass(['form-check-label ps-2 pe-2', (!_ctx.element.isOptional && !_ctx.isChecked(_ctx.data[tField.member])) ? 'text-white bg-danger' : ''])
                                                            }, " Zustimmen ", 2)
                                                        ])
                                                    ])
                                                ]),
                                                _: 2
                                            }, 1032, ["error-message"]))
                                            : _createCommentVNode("", true)
                ]),
                (_ctx.element.isMultipleOccurs && _ctx.content.fields.length > 1)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                        _createVNode(_component_g_button, {
                            text: "Löschen",
                            onClick: ($event) => (_ctx.onMultiRemove(tField))
                        }, null, 8, ["onClick"])
                    ]))
                    : _createCommentVNode("", true)
            ]));
        }), 128)),
        _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.element.info), 1),
        (_ctx.element.isMultipleOccurs)
            ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                _createVNode(_component_g_button, {
                    text: "+ Hinzufügen",
                    style: { "max-width": "150px" },
                    onClick: _ctx.onMultiAdd
                }, null, 8, ["onClick"])
            ]))
            : _createCommentVNode("", true)
    ]));
}
